/** Formats a note timestamp for the patient Notes tab (e.g. "24 July 2025, 10:15 AM"). */
export function formatNoteDateTime(date: Date): string {
  const datePart = date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  const timePart = date
    .toLocaleTimeString("en-GB", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })
    .replace(/\b(am|pm)\b/gi, (m) => m.toUpperCase());
  return `${datePart}, ${timePart}`;
}
